import { getAppImplementation, patchTask } from '@fno/service/api/tasks.js'
import { getUsersWithSchoolAccess, patchUser, createUser } from '@fno/service/api/users.js'
import { getSchool, patchSchool } from '@fno/service/api/schools.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler } from '@fno/route/hello/task/helpers.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import schoolSchema from 'fanx-schema/resource/school'
import appImplementationSchema from 'fanx-schema/resource/taskAppImplementation'
import userSchema from 'fanx-schema/resource/user'
import template from './ContactInfo.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    school: {
        type: Object,
        schema: schoolSchema,
        patch: (school) => patchSchool({ school })
    },
    schoolOnboarding: {
        type: Object,
        schema: appImplementationSchema,
        patch: (task) => patchTask({ task })
    },
    users: {
        type: Array,
        schema: userSchema,
        patch: (user) => patchUser({ user }),
        post: (user) => createUser({ user })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.contactInfo`

    stateRouter.addState({
        name,
        route: '/contactInfo',
        template,
        data: {
            title: 'Contact Info | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ school, users, schoolOnboarding ] = await Promise.all([
                getSchool({ schoolId }),
                getUsersWithSchoolAccess({ schoolId, roles: [ '-fnoexdev', '-fnoexsupport', '-prestosupport' ] }),
                getAppImplementation({ schoolId })
            ])

            return setContextOriginal(
                {
                    context: {
                        form: {
                            school: transformApiResponseToFormObject({ schema: schoolSchema, data: school }),
                            schoolOnboarding: transformApiResponseToFormObject({
                                schema: appImplementationSchema,
                                data: schoolOnboarding
                            }),
                            users: users.map((user) =>
                                transformApiResponseToFormObject({ schema: userSchema, data: user })
                            )
                        }
                    }
                },
                preFormMutator
            )
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'CONTACT_INFO',
                nextId: 'appNaming'
            }))
            component.$on('save', save)
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
        }
    })
}
